import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getdashboarddata } from '../../store/services/shared';
import { STALE_TIMES } from 'src/utils/constants/queryConstants';
import { track } from '../../utils/telemetry';

const GetDashboardData = (data: any) => {
  return getdashboarddata(data);
};

export const useGetDashboardData = (data: any) => {
  return useQuery({
    queryKey: ['dashboardData'],
    queryFn: async () => {
      try {
        return await GetDashboardData(data);
      } catch (error) {
        track('GetDashboardData  -- ERROR:', { error });
        throw error;
      }
    },
    staleTime: STALE_TIMES.THIRTY_MINUTES,
  });
};
